import FalconCardHeader from 'components/common/FalconCardHeader';
import React from 'react';
import { Card, Col, Row } from 'react-bootstrap';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import Flex from 'components/common/Flex';

const SuggessionSkeleton = () => {
  return (
    <Row className="w-100 d-flex align-items-center py-2">
      <Col className=" w-100 py-1 pe-0">
        <div className="w-100 d-flex align-items-center justify-content-start">
          <div className="w-25">
            <Skeleton circle width={40} height={40} />
          </div>
          <div className="w-75">
            <Skeleton width={'100%'} />
          </div>
        </div>
      </Col>
    </Row>
  );
};

const SeedSuggestionSkeleton = () => {
  return (
    <Card>
      <FalconCardHeader title={<Skeleton />} titleTag="h5" light={true} />

      <Card.Body className="pb-0">
        {[...Array(4).keys()].map(index => (
          <SuggessionSkeleton key={index} />
        ))}
      </Card.Body>
      <Card.Footer className="text-center">
        <Skeleton width={'50%'} height={25} />
      </Card.Footer>
    </Card>
  );
};

export default SeedSuggestionSkeleton;
